import { useState, useEffect }            from "react";
import { atom, useAtomValue, useSetAtom } from "jotai";
import { atomWithStorage }                from "jotai/utils";
import Cookies                            from "js-cookie";

export const loginPopupAtom = atom ( false );
export const localePopupAtom = atom ( false );
export const drawerAtom = atom ( false );
export const interestialPopupAtom = atom ( false );
export const liveChatInfoPopupAtom = atom ( false );

export const darkModeAtom = atomWithStorage ( "darkMode", true );
export const appLocaleAtom = atomWithStorage ( "app-locale", "en" );
export const systemThemeAtom = atomWithStorage ( "isDeviceTheme", true );

export const useSetLoginPopup = () => {
	return useSetAtom ( loginPopupAtom );
};

export const useGetLoginPopup = () => {
	return useAtomValue ( loginPopupAtom );
};

export const useSetLocalePopup = () => {
	return useSetAtom ( localePopupAtom );
};

export const useGetLocalePopup = () => {
	return useAtomValue ( localePopupAtom );
};

export const useSetDrawer = () => {
	return useSetAtom ( drawerAtom );
};

export const useGetDrawer = () => {
	return useAtomValue ( drawerAtom );
};

export const useSetInterestialPopup = () => {
	return useSetAtom ( interestialPopupAtom );
};

export const useGetInterestialPopup = () => {
	return useAtomValue ( interestialPopupAtom );
};

export const useSetLiveChatInfoPopup = () => {
	return useSetAtom ( liveChatInfoPopupAtom );
};

export const useGetLiveChatInfoPopup = () => {
	return useAtomValue ( liveChatInfoPopupAtom );
};

export const useSetAppLocale = () => {
	return useSetAtom ( appLocaleAtom );
};

export const useGetAppLocale = () => {
	return useAtomValue ( appLocaleAtom );
};

export const useSetDarkMode = () => {
	const [ value, setValue ] = useState ();
	const setDarkMode         = useSetAtom ( darkModeAtom );

	useEffect ( () => {
		if ( value === undefined )
			return;

		setDarkMode ( value );

		Cookies.set ( "darkMode", value );
	}, [ value ] );

	return setValue;
};

export const useGetDarkMode = () => {
	return useAtomValue ( darkModeAtom );
};

export const useSetDeviceTheme = () => {
	return useSetAtom ( systemThemeAtom );
};

export const useGetDeviceTheme = () => {
	return useAtomValue ( systemThemeAtom );
};
